import React, { useId, useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';
import AssetIcon from '../../assets/AssetIcon';
import { isFilterActive } from '../../data/moduleFilters';
import IconAction from '../IconAction';

export default function FilterDropdown({ group, value, onChange }) {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const id = useId();
  const active = isFilterActive(value, group);
  const options = group.options || [];
  const selected = Array.isArray(value) ? value.map(String) : [String(value ?? '')];
  const choice = options.find((option) => String(option.value) === String(value));
  let summary = 'Tutti';
  if (active) {
    if (Array.isArray(value)) {
      summary = value.length === 1 ? choice?.label || String(value[0]) : `${value.length} selezionati`;
    } else if (typeof value === 'object') {
      const bound = (number) => number === 0 ? '0' : number || '…';
      summary = `${bound(value.min)} – ${bound(value.max)}`;
    } else {
      summary = choice?.label || String(value);
    }
  }
  const reset = () => {
    setQuery('');
    onChange(group.kind?.endsWith('-range') ? {} : group.kind === 'text' ? '' : group.selection === 'multi' ? [] : group.emptyValue ?? group.allValue ?? '');
  };
  const kind = group.kind || 'options';
  // The reset action replaces the old "Tutti" item; actual defaults such as
  // "Mese" or "Da sempre" remain selectable.
  const selectableOptions = options.filter((option) => !(String(option.value) === String(group.emptyValue ?? group.allValue ?? '') && /^(tutt[ioae]|all)\b/i.test(option.label)));
  const visibleOptions = selectableOptions.filter((option) => String(option.label).toLocaleLowerCase('it').includes(query.toLocaleLowerCase('it')));
  return (
    <div className="wt-filter-dropdown-field">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" className={`wt-filter-dropdown ${active ? 'is-active' : ''}`} aria-label={`${group.label}: ${summary}`}>
            <span className="wt-filter-dropdown__value"><strong>{group.label}</strong>{active ? <span className="wt-filter-dropdown__summary">{summary}</span> : null}</span>
            <AssetIcon name="actions.arrowDown" size={16} />
          </button>
        </PopoverTrigger>
        <PopoverContent align="start" className="wt-filter-dropdown__menu" aria-label={group.label}>
          {kind.endsWith('-range') ? (
            <div className="wt-filter-dropdown__range">
              {['min', 'max'].map((bound) => <label key={bound} htmlFor={`${id}-${bound}`}>
                {bound === 'min' ? 'Da' : 'A'}
                <input id={`${id}-${bound}`} type={kind === 'date-range' ? 'date' : 'number'} step="any"
                  value={value?.[bound] ?? ''} onChange={(event) => onChange({ ...value, [bound]: event.target.value })} />
              </label>)}
            </div>
          ) : kind === 'text' ? (
            <label htmlFor={id}>Contiene<input id={id} value={value || ''} onChange={(event) => onChange(event.target.value)} /></label>
          ) : (
            <>
              {selectableOptions.length > 8 ? <label className="wt-filter-dropdown__search" htmlFor={id}>
                <span className="sr-only">Cerca valore</span>
                <input id={id} value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Cerca..." />
              </label> : null}
              <div className="wt-filter-dropdown__options">
                {visibleOptions.map((option) => <label key={String(option.value)} className="wt-filter-dropdown__option">
                  <input type={group.selection === 'multi' ? 'checkbox' : 'radio'} name={`${id}-choice`}
                    checked={selected.includes(String(option.value))} disabled={option.disabled}
                    onChange={() => {
                      if (group.selection === 'multi') {
                        const current = Array.isArray(value) ? value : [];
                        onChange(selected.includes(String(option.value)) ? current.filter((item) => String(item) !== String(option.value)) : [...current, option.value]);
                      } else { onChange(option.value); setOpen(false); }
                    }} />
                  <span>{option.label}</span>
                </label>)}
                {!visibleOptions.length ? <p>Nessun valore disponibile.</p> : null}
              </div>
            </>
          )}
        </PopoverContent>
      </Popover>
      <IconAction iconKey="actions.reset" label={`Reimposta ${group.label}`} onClick={reset} disabled={!active && !query} size={32} />
    </div>
  );
}
